import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=7506224e&"
import script from "./ColorSwatch.vue?vue&type=script&lang=ts&"
export * from "./ColorSwatch.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=7506224e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports